import {StructuredTable} from '../StructuredTableConstants';

/**
 * Check if the length of a table should be locked. This is only true when the table is present, the table is not in a template (isConfig is false), and metadata.lockRowCount is present and true.
 *
 * This should stay in sync with the is_table_length_locked in structured_tables/util.py.
 *
 * @param structuredTable The table to evaluate - if undefined or not provided, the function will return false.
 * @returns True if table length should be locked, and false if not.
 */
export function isTableLengthLocked(structuredTable?: StructuredTable<unknown, unknown>): boolean {
  if (structuredTable == null) {
    return false;
  }
  return !structuredTable.isConfig && (structuredTable.metadata.lockRowCount ?? false);
}
